
import { defineComponent } from 'vue';
import { IRelease } from '@/types/models';
import utils from '@/utils';
import api from '@/api/admin/v6';

interface IState {
  releases: IRelease[];
  latestNightlyRelease?: IRelease;
  latestStableRelease?: IRelease;
  latestNightlyVersion?: string;
  latestStableVersion?: string;
}

export default defineComponent({
  data() {
    return {
      releases: [],
      latestNightlyRelease: undefined,
      latestStableRelease: undefined,
      latestNightlyVersion: undefined,
      latestStableVersion: undefined,
    } as IState;
  },
  methods: {
    apiGet() {
      api.get((res) => {
        this.releases = res.releases;
        this.latestNightlyRelease = res.latestNightlyRelease;
        this.latestStableRelease = res.latestStableRelease;
      });
    },

    apiPublish(version: string) {
      api.publish(version, (res) => {
        this.releases = res.releases;
        this.latestNightlyRelease = res.latestNightlyRelease;
        this.latestStableRelease = res.latestStableRelease;

        utils.success(`新版本${version}发布成功！`);
      });
    },

    apiPull() {
      api.pull((res) => {
        this.latestNightlyVersion = res.latestNightlyVersion;
        this.latestStableVersion = res.latestStableVersion;
        utils.success('新版本检测成功！');
      });
    },

    isNotIn(version: string) {
      return this.releases.findIndex((o) => o.version === version) === -1;
    },

    btnPullClick() {
      this.apiPull();
    },

    btnPublishClick(version: string) {
      this.apiPublish(version);
    },
  },
  mounted() {
    this.apiGet();
  },
});
